import { render, staticRenderFns } from "./ExpandableCard.vue?vue&type=template&id=3fecb60c&scoped=true&"
import script from "./ExpandableCard.vue?vue&type=script&lang=ts&"
export * from "./ExpandableCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fecb60c",
  null
  
)

export default component.exports